export const SUCCESS_DEFAULT_TEXT = 'Ответ на ваш вопрос придет по указанным реквизитам.';
export const ERROR_DEFAULT_TEXT   = 'У нас произошел сбой в работе оборудования. Почитайте, пожалуйста, другие статьи, а позже попробуйте еще раз!';



// WEBPACK FOOTER //
// ./src/components/modalform/const.js